import { Link } from "react-router-dom";
import { Hero } from "@/components/home/Hero";
import { Intro } from "@/components/home/Intro";
import { NewsSection } from "@/components/home/NewsSection";
import { Gallery } from "@/components/home/Gallery";
import { InfoSection } from "@/components/home/InfoSection";
import { DocumentsSection } from "@/components/home/DocumentsSection";
import { DepotCTA } from "@/components/home/DepotCTA";
import { PartnersSection } from "@/components/home/PartnersSection";
import { PartnerCTA } from "@/components/home/PartnerCTA";
import { HistoryTeaser } from "@/components/home/HistoryTeaser";
import { FaqSection } from "@/components/home/FaqSection";
import { ContactSection } from "@/components/home/ContactSection";

export default function Home() {
  return (
    <>
      <Hero />
      <Intro />
      <NewsSection limit={3} />
      <Gallery />
      <InfoSection />
      <section data-testid="home-schedule-link" className="py-10 bg-[#0A0B0D]">
        <div className="mx-auto max-w-5xl px-5 sm:px-8 text-center">
          <Link to="/tavlingsinformation" className="font-display text-xl sm:text-2xl font-bold uppercase text-white hover:text-amber-500 transition-colors">Se fullständigt tidsschema under <span className="text-amber-500">Tävlingsinfo</span>.</Link>
        </div>
      </section>
      <DepotCTA />
      <DocumentsSection limit={6} />
      <PartnersSection />
      <PartnerCTA />
      <HistoryTeaser />
      <FaqSection />
      <ContactSection />
    </>
  );
}
